import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const getHeaders = () => {
  const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
  const token = personalDetails?.loginToken;
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
};

export const login = async (credentials) => {
  try {
    const response = await axios.post(
      `${baseUrl}login/`,
      credentials,
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Login failed.';
  }
};

export const placeOrder = async (orderData) => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.post(
      `${baseUrl}order/`, // Replace with your actual endpoint
      orderData,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Order placement failed.';
  }
};

export const getOrder = async () => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}order/`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};

export const getSingleOrder = async (num) => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}order-slip/${num}/`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};

export const fetchData = async (endpoint) => {
  try {
    const response = await axios.get(`${baseUrl}/${endpoint}`, {
      headers: getHeaders(),
    });
    return response.data;
  } catch (error) {
    if (error.response?.status === 401) {
      localStorage.removeItem('personalDetails');
      window.location.href = '/';
    }
    throw error.response?.data?.message || 'Error fetching data.';
  }
};

export const fetchWalletData = async () => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}wallet-details/`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};
export const getWinnersHistory = async () => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}winners-history/`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};
export const getAcountHistory = async (formDate, toDate) => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}account-report/?from_date=${formDate}&to_date=${toDate}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};

export const barcodeScanSeeWinner = async (number) => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}winner-and-claim/?order_number=${number}`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`, // Pass the token in the header
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};

export const lastOrderCancel = async () => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.put(
      `${baseUrl}order-cancel/`,
      {},
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};
export const claimWinningAmount = async (number) => {
  try {
    const personalDetails = JSON.parse(localStorage.getItem('personalDetails'));
    const token = personalDetails?.LoginToken;

    const response = await axios.get(
      `${baseUrl}winner-and-claim/?order_number=${number}&claim=True`,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || 'Get Order Data.';
  }
};
